import { enumRoles, enumPermissions as permission } from "data/enums/authorization";
import { moduleNames } from "data/enums/modules";

const { ADMIN } = enumRoles

const allRoles = [ADMIN]
const allAdminRoles = [ADMIN]


const routes = [
  {
    id: 'admin',
    auth: {
      roles: allAdminRoles
    },
    modules: [
      {
        id: moduleNames.ADMIN_REPORT, to: '/admin/report',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_EMPLOYEES] },
        routes: [
          {
            id: moduleNames.ADMIN_REPORT_EMPLOYEES, to: '/admin/report/employees',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_EMPLOYEES] },
          },
          {
            id: moduleNames.ADMIN_REPORT_WORKING_SITES, to: '/admin/report/working-sites',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_WORKING_SITES] },
          },
          {
            id: moduleNames.ADMIN_REPORT_WORK_TABLE, to: '/admin/report/work-table',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_WORK_TABLE] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_USERS, to: '/admin/users',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_LIST] },
      },
      {
        id: moduleNames.ADMIN_EMPLOYEES, to: '/admin/employees',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_EMPLOYEES_LIST] },
      },
      {
        id: moduleNames.ADMIN_EMPLOYEES_NOTES, to: '/admin/employees-notes',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_EMPLOYEES_NOTES_LIST] },
      },
      {
        id: moduleNames.ADMIN_COMPANIES, to: '/admin/companies',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_COMPANIES_LIST] },
      },
      {
        id: moduleNames.ADMIN_EMPLOYEES_ABSENCE, to: '/admin/employees-absence',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_EMPLOYEES_ABSENCE_LIST] },
      },
      {
        id: moduleNames.ADMIN_SPREADSHEETS, to: '/admin/spreadsheets',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_SPREADSHEETS_LIST] },
      },
      {
        id: moduleNames.ADMIN_GROUPS, to: '/admin/groups',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_GROUPS_LIST] },
      },
      /*   {
          id: moduleNames.ADMIN_FORMS_DROPDOWN, to: '/admin/forms',
          auth: { roles: allAdminRoles, permissions: [permission.ADMIN_FORMS_TEMPLATES_LIST, permission.ADMIN_FORMS_SUBMISSIONS_LIST] },
          routes: [
            {
              id: moduleNames.ADMIN_FORMS_TEMPLATES, to: '/admin/forms/templates',
              auth: { roles: allAdminRoles, permissions: [permission.ADMIN_FORMS_TEMPLATES_LIST] },
            },
            {
              id: moduleNames.ADMIN_FORMS_SUBMISSIONS, to: '/admin/forms/submissions',
              auth: { roles: allAdminRoles, permissions: [permission.ADMIN_FORMS_SUBMISSIONS_LIST] },
            }
          ]
        }, */
      {
        id: moduleNames.ADMIN_WORKING_SITES, to: '/admin/working-sites',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_WORKING_SITES_LIST] },
      },
      {
        id: moduleNames.ADMIN_WORKING_SITES_PLANNER, to: '/admin/working-sites-planner',
        auth: { roles: allAdminRoles, permissions: [] },
      },
      {
        id: moduleNames.ADMIN_WORKING_HOURS_DROPDOWN, to: '/admin/working-hours',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_WORKING_HOURS_LIST, permission.ADMIN_WORKING_HOURS_SUBMISSIONS_LIST] },
        routes: [
          {
            id: moduleNames.ADMIN_WORKING_HOURS_SUBMISSIONS, to: '/admin/working-hours/submissions',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_WORKING_HOURS_SUBMISSIONS_LIST] },
          },
          {
            id: moduleNames.ADMIN_WORKING_HOURS, to: '/admin/working-hours/annual',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_WORKING_HOURS_LIST] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_TAX_SCALES, to: '/admin/tax-scales',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_TAX_SCALES_LIST] },
      },
      {
        id: moduleNames.ADMIN_TAX_EMPLOYEES, to: '/admin/tax-employees',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_TAX_EMPLOYEES_LIST] },
      },
      {
        id: moduleNames.ADMIN_CANTONS, to: '/admin/cantons',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_CANTONS_LIST] },
      },
      {
        id: moduleNames.ADMIN_CANTONS_HOLIDAYS, to: '/admin/cantons-holidays',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_CANTONS_HOLIDAYS_LIST] },
      },
      {
        id: moduleNames.ADMIN_COMMUNE, to: '/admin/commune',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_COMMUNE_LIST] },
      },
      {
        id: moduleNames.ADMIN_CITIES, to: '/admin/cities',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_CITIES_LIST] },
      },

    ]
  },

  {
    id: 'system',
    auth: {
      roles: allRoles
    },
    modules: [
      {
        id: moduleNames.ADMIN_PROFILE, to: '/admin/profile',
        auth: { roles: allRoles, presmissions: [] },
      }
    ]
  },

]

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_STAGING !== 'true') {
  const devRoutes = {
    id: 'dev',
    auth: {
      roles: allRoles
    },
    modules: [
      {
        id: `${moduleNames.DEV_BUILDER_DROPDOWN}_admin`, to: '/admin/builder',
        auth: { roles: allAdminRoles, permissions: [] },
        routes: [
          {
            id: `${moduleNames.DEV_BUILDER_MODULE}_admin`, to: '/admin/builder/module',
            auth: { roles: allAdminRoles, permissions: [] },
          }
        ]
      }
    ]
  }
  routes.push(devRoutes)
}


export default routes